'use client';

import { type TProduct } from '@/common/types/analytics.type';
import { cssTransition, toast } from 'react-toastify';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';
import Text from '@/common/components/text/text.component';
import CheckIcon from '~/public/assets/images/svg/check-icon.svg';
import ErrorIcon from '~/public/assets/images/svg/Error-icon.svg';
import InformationIcon from '~/public/assets/images/svg/information-icon.svg';

const bounce = cssTransition({
  enter: 'toast-in',
  exit: 'toast-out',
});

export default function Toast() {}

function Success(message: string) {
  const toastId = message.replaceAll(' ', '-');

  return toast.success(message, {
    toastId,
    style: {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      backgroundColor: 'rgb(25, 19, 8,0.85)',
      borderRadius: '6px',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: '500',
      height: '48px',
    },
    // eslint-disable-next-line sonarjs/no-duplicate-string
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: bounce,
    icon: <CheckIcon className="mb-[2px]" />,
  });
}

function Error(message: string) {
  const toastId = message.replaceAll(' ', '-');

  return toast.error(message, {
    toastId,
    style: {
      backgroundColor: 'rgb(25, 19, 8,0.85)',
      borderRadius: '6px',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: '500',
    },
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: bounce,
    icon: <ErrorIcon className="mb-[2px]" />,
  });
}

function Info(message: string) {
  const toastId = message.replaceAll(' ', '-');

  return toast.info(message, {
    toastId,
    style: {
      backgroundColor: 'rgb(25, 19, 8,0.85)',
      borderRadius: '6px',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: '500',
      height: '48px',
    },
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: bounce,
    icon: <InformationIcon className="mb-[2px]" />,
  });
}

function CallToAction(
  message: string,
  Icon?: React.ReactElement | null,
  buttonAction?: () => void,
  buttonTitle?: string,
  id?: keyof TProduct
) {
  const CustomComponent = () => {
    return (
      <div className="flex h-full w-full items-center justify-between  ">
        <Text className="mb-4 text-xs font-medium text-white">{message}</Text>
        {id ? (
          <AnalyticsWrapper analytics={[id]}>
            <Button id={id} className="mb-4" type="link" onClick={buttonAction}>
              {buttonTitle}
            </Button>
          </AnalyticsWrapper>
        ) : (
          <Button id={id} className="mb-4" type="link" onClick={buttonAction}>
            {buttonTitle}
          </Button>
        )}
      </div>
    );
  };
  const toastId = message.replaceAll(' ', '-');

  return toast(<CustomComponent />, {
    toastId,
    style: {
      backgroundColor: 'rgb(25, 19, 8,0.85)',
      borderRadius: '6px',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: '500',
      height: '48px',
      zIndex: '1000',
    },
    position: 'bottom-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: bounce,
    icon: Icon || undefined,
  });
}

Toast.success = Success;
Toast.error = Error;
Toast.info = Info;
Toast.callToAction = CallToAction;
